import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import vuetify from './plugins/vuetify';
import '@/scss/style.scss';
import PerfectScrollbar from 'vue3-perfect-scrollbar';
import VueApexCharts from 'vue3-apexcharts';
import VueTablerIcons from 'vue-tabler-icons';
import 'vue3-carousel/dist/carousel.css';
import PrimeVue from "primevue/config";
import Aura from '@primevue/themes/aura';
//Mock Api data
import './_mockApis';
// import VueDragscroll from "vue-dragscroll";
import GoogleSignInPlugin from "vue3-google-signin"
import { install } from 'vue3-recaptcha-v2'

import Maska from 'maska';

// Table
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
//i18
import { createI18n } from 'vue-i18n';
import messages from '@/utils/locales/messages';

//ScrollTop
import VueScrollTo from 'vue-scrollto';

//LightBox
import VueEasyLightbox from 'vue-easy-lightbox';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { setLogoutHandler } from '@/utils/axios'; 
import { useAuthStore } from '@/stores/auth';
import * as Sentry from "@sentry/vue";





setLogoutHandler(() => {
  const authStore = useAuthStore();
  authStore.logout();
  
  router.push({ name: 'login' });
});

const i18n = createI18n({
    locale: 'en',
    messages: messages,
    silentTranslationWarn: true,
    silentFallbackWarn: true
});

const app = createApp(App);
app.use(router);
app.component('EasyDataTable', Vue3EasyDataTable);
app.use(PerfectScrollbar);
// app.use(VueDragscroll);
const pinia = createPinia();
// add persistence plugin here
Sentry.init({
  app,
  dsn: "https://ffed83977aee41fa1a37abd27ab9ccd8@o4507244030918656.ingest.de.sentry.io/4509630784798800",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: "system",
      isNameRequired: true,
      isEmailRequired: true,
      autoInject: false,
    }),
    Sentry.browserTracingIntegration(),
    Sentry.vueIntegration({
      tracingOptions: {
        trackComponents: ["Header", "Navigation", "Footer"],
        hooks: ["create", "mount"],
      },
    }),
    
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/aral\.ngohs-apps\.com/],

});
app.use(pinia);
app.use(GoogleSignInPlugin, {
    clientId: '331168977949-8rfjtcfjqn9bt7drd0bbqu2t0s6sdid2.apps.googleusercontent.com'
});
app.use(install, {
    sitekey: '6LcBVsAqAAAAAHMFG-83A6ag9YUhh8TxPpNXeFlH',
    cnDomains: false
})
app.use(VueTablerIcons);
app.use(i18n);
app.use(Maska);
app.use(VueApexCharts);

app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: 'off'
        }
    }
});








//ScrollTop Use
// app.use(VueScrollTo);
app.use(VueScrollTo, {
    duration: 1000,
    easing: "ease"
});

//Lightbox
app.use(VueEasyLightbox)

app.use(vuetify).mount('#app');
